<script lang="ts">import Clarity from "./includes/clarity.svelte";
import Mixpanel from "./includes/mixpanel.svelte";
import Optimove from "./includes/optimove.svelte";
import Google from "./includes/google.svelte";
import { cfgGoogleAnalytics, cfgGoogleClientId, cfgGoogleTagManager } from "@infinitro/config";
import { cfgOptimoveEnabled } from "@infinitro/config";
import { cfgMicrosoftClarityId } from "@infinitro/config";
import { cfgMixPanelConfig } from "@infinitro/config";
const clarityEnabled = cfgMicrosoftClarityId() != undefined;
const optimoveEnabled = cfgOptimoveEnabled();
const googleEnabled = cfgGoogleAnalytics() || cfgGoogleTagManager() || cfgGoogleClientId();
const mixpanelEnabled = cfgMixPanelConfig() != undefined;
</script>

{#if optimoveEnabled}
	<Optimove />
{/if}
{#if googleEnabled}
	<Google />
{/if}
{#if clarityEnabled}
	<Clarity />
{/if}
{#if mixpanelEnabled}
	<Mixpanel />
{/if}
